import React from 'react';
import {connect} from 'react-redux';
import {Field, Form, Formik} from 'formik';
import * as Yup from 'yup';
import {Col, Modal, Row} from 'react-bootstrap';
import {utilActions} from '../../../_actions';
import {ERR, ErrorMessage, LoadingBoton} from '../../../_helpers';
import {empresaActions} from '../../../_actions/empresa.actions';

class FormEmpresa extends React.Component {

    componentDidMount() {

    }

    state = {
        grabando: false
    }

    setGrabando = (grabando) => {
        this.setState({grabando: grabando});
    }

    render() {
        let {empresa} = this.props;

        let inic = {
            id: '',
            classColor: '',
            nombre: '',
            dns: '',
            logoUrl: ''
        }

        if (empresa !== undefined) inic = utilActions.setearValores(inic, empresa);

        const validationSchema = Yup.object().shape({
            // classColor: Yup.string().min(2, 'Muy corto').max(150, 'Muy largo').required(ERR.REQ),
            nombre: Yup.string().min(2, 'Muy corto').max(250, 'Muy largo').required(ERR.REQ),
            //  logoUrl: Yup.string().min(2, 'Muy corto').max(250, 'Muy largo').required(ERR.REQ),
            //  dns: Yup.string().min(2, 'Muy corto').max(250, 'Muy largo').required(ERR.REQ)
        });

        return (

            <div>
                <Modal show={this.props.show} onHide={() => this.props.handleClose()} backdrop="static"
                       keyboard={false}>
                    <Modal.Header className="bg-iot text-dark" closeButton>
                        <Modal.Title><span
                            class="material-icons material-icons-outlined">ballot</span> Empresa</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Formik
                            enableReinitialize={true}
                            initialValues={inic}
                            validationSchema={validationSchema}
                            onSubmit={values => {
                                this.props.grabar(values, this.props.handleClose, this.setGrabando);
                            }}
                        >
                            {({errors, touched, values, setFieldValue}) => (
                                <Form>
                                    <Row className="justify-content-center mt-4 mb-4">
                                        <Col xs="12">
                                            <label className="font-weight-bold" htmlFor="nombre">Nombre </label>
                                            <ErrorMessage name={`nombre`}/>
                                            <Field name="nombre"/>

                                        </Col>
                                        {/* <Col xs="12">
                                            <label className="font-weight-bold" htmlFor="classColor">Class
                                                Color </label>
                                            <ErrorMessage name={`classColor`}/>
                                            <Field name="classColor"/>

                                        </Col>

                                        <Col xs="12">
                                            <label className="font-weight-bold" htmlFor="dns">Dns </label>
                                            <ErrorMessage name={`dns`}/>
                                            <Field name="dns"/>

                                        </Col>

                                        <Col xs="12">
                                            <label className="font-weight-bold" htmlFor="logoUrl">logoUrl </label>
                                            <ErrorMessage name={`logoUrl`}/>
                                            <Field name="logoUrl"/>

                                        </Col> */}

                                    </Row>

                                    <div className="justify-content-center mt-5 p-3 row border-top bg-light">
                                        <button className="btn btn-link text-secundario cursor mr-3" type="button"
                                                onClick={() => this.props.handleClose()}>
                                            <i className="icon-times"></i> Cerrar
                                        </button>
                                        <button className="btns btns-secundario" type="submit"
                                                disabled={this.state.grabando}>
                                            <i className="icon-floppy"></i> Grabar <LoadingBoton
                                            grabando={this.state.grabando}/>
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>


                    </Modal.Body>
                </Modal>

            </div>
        )
    };
}

function mapState(state) {
    return {};
}

const actionCreators = {
    grabar: empresaActions.grabar
}

const connectedFormEmpresa = connect(mapState, actionCreators)(FormEmpresa);
export {connectedFormEmpresa as FormEmpresa};